import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useLanguage } from "../language/LanguageConfig";
import LanguageSwitcher from "../language/LanguageSwitcher";
import MobileSw from "../language/MoblieSw";
import { Language } from "../language/context";

const HeaderContainer = styled.header`
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
`;

const NavContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
`;

const Logo = styled(Link)`
  font-size: 1.5rem;
  font-weight: 700;
  color: #22365c;
  text-decoration: none;
  display: flex;
  align-items: center;

  img {
    width: 240px;
    margin-right: 0.5rem;
  }
`;

const NavLinks = styled.nav`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled(Link)`
  margin-left: 2rem;
  color: #333;
  text-decoration: none;
  font-weight: 500;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 0;
    height: 2px;
    background-color: #414142;
    transition: width 0.3s ease;
  }

  &:hover:after,
  &.active:after {
    width: 100%;
  }
`;

// 드롭다운 메뉴를 위한 스타일 컴포넌트
const NavLinkWithDropdown = styled.div`
  margin-left: 2rem;
  position: relative;
  display: flex;
  align-items: center;
  bottom: 1px;
`;

const DropdownButton = styled.button`
  background: none;
  border: none;
  color: #333;
  font-weight: 500;
  font-size: 1rem;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 0;
    height: 2px;
    background-color: #414142;
    transition: width 0.3s ease;
  }

  &:hover:after {
    width: 100%;
  }
`;

const DropdownIcon = styled.span`
  margin-left: 5px;
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
  transition: transform 0.3s ease;

  ${(props) =>
    props.$isOpen &&
    `
    transform: rotate(180deg);
  `}
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  min-width: 180px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 0.5rem 0;
  margin-top: 10px;
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  visibility: ${(props) => (props.$isOpen ? "visible" : "hidden")};
  transform: ${(props) =>
    props.$isOpen ? "translateY(0)" : "translateY(-10px)"};
  transition: all 0.3s ease;
  z-index: 200;
`;

const DropdownItem_2 = styled(Link)`
  display: block;
  padding: 0.75rem 1rem;
  color: #333;
  text-decoration: none;
  font-weight: 400;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;

  &:hover {
    background-color: #f8f9fa;
    color: #22365c;
  }
`;

const DropdownItem = styled.a`
  display: block;
  padding: 0.75rem 1rem;
  color: #333;
  text-decoration: none;
  font-weight: 400;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;

  &:hover {
    background-color: #f8f9fa;
    color: #22365c;
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #333;
  cursor: pointer;
  padding: 8px;
  z-index: 101;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const MobileMenu = styled.div`
  position: absolute; /* 또는 fixed */
  top: 80px;
  right: 1rem; /* 또는 0 */
  background-color: #fff;
  padding: 1rem;
  width: 200px; /* 메뉴 폭 지정 */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transform: ${(props) =>
    props.$isOpen ? "translateY(0)" : "translateY(-10px)"};
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  visibility: ${(props) => (props.$isOpen ? "visible" : "hidden")};
  transition: all 0.3s ease;
  z-index: 99;

  overflow-y: auto;
  max-height: calc(100vh - 80px); /* 전체 뷰 높이에서 top 만큼 빼기 */
  /* 스크롤바 숨기기 (브라우저별) */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE & Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }
  @media (min-width: 769px) {
    display: none;
  }
`;

const MobileNavLink = styled(Link)`
  display: block;
  padding: 0.8rem;
  color: #333;
  text-decoration: none;
  font-weight: 500;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }

  &:hover,
  &.active {
    color: #22365c;
    background-color: #f8f9fa;
  }
`;

// 모바일 드롭다운 메뉴 스타일
const MobileDropdownButton = styled.button`
  display: block;
  width: 100%;
  text-align: left;
  padding: 0.8rem;
  color: #333;
  background: none;
  border: none;
  font-weight: 500;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1rem;

  &:hover {
    color: #22365c;
    background-color: #f8f9fa;
  }
`;

const MobileDropdownMenu = styled.div`
  background-color: #f8f9fa;
  overflow: hidden;
  max-height: ${(props) => (props.$isOpen ? "500px" : "0")};
  transition: max-height 0.3s ease;
`;

const MobileDropdownItem = styled.a`
  display: block;
  padding: 1rem 1rem 1rem 2rem;
  color: #333;
  text-decoration: none;
  font-weight: 400;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    color: #22365c;
    background-color: #f0f0f0;
  }
`;

const MobileDropdownItem_2 = styled(Link)`
  display: block;
  padding: 1rem 1rem 1rem 2rem;
  color: #333;
  text-decoration: none;
  font-weight: 400;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    color: #22365c;
    background-color: #f0f0f0;
  }
`;

// 햄버거 아이콘 SVG 컴포넌트
const HamburgerIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 12H21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M3 6H21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M3 18H21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

// X 아이콘 SVG 컴포넌트
const CloseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 6L6 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M6 6L18 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [partnerDropdownOpen, setPartnerDropdownOpen] = useState(false);

  const [insightDropdownOpen, setInsightDropdownOpen] = useState(false);
  const [mobileInsightDropdownOpen, setMobileInsightDropdownOpen] =
    useState(false);
  const [mobilePartnerDropdownOpen, setMobilePartnerDropdownOpen] =
    useState(false);
  const [mobileLanguageDropdownOpen, setMobileLanguageDropdownOpen] =
    useState(false);

  const toggleDropdown = (dropdown) => {
    setMobileInsightDropdownOpen(
      dropdown === "insight" ? !mobileInsightDropdownOpen : false,
    );
    setMobilePartnerDropdownOpen(
      dropdown === "partner" ? !mobilePartnerDropdownOpen : false,
    );
    setMobileLanguageDropdownOpen(
      dropdown === "language" ? !mobileLanguageDropdownOpen : false,
    );
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const { dictionary, lang } = useLanguage();

  const context = dictionary.header;
  // 파트너사 드롭다운 데이터
  const partnerSites = [
    { name: `${context.nav.wethepeople}`, url: "http://www.wethepeople.co.kr" },
  ];

  const InsightSites = [
    { name: `${context.nav.updates}`, to: "notice" },
    { name: `${context.nav.publications}`, to: "publications" },
    { name: `${context.nav.news}`, to: "news" },
    { name: `${context.nav.newsletters || "Newsletters"}`, to: "newsletters" },
    { name: `${context.nav.recruit}`, to: "recruit" },
    { name: `${context.nav.track}`, to: "cases" },
    //{ name: `${context.nav.cases}`, to: "cases" },
  ];

  const InsightSites_encn = [
    { name: `${context.nav.updates}`, to: "notice" },
    { name: `${context.nav.publications}`, to: "publications" },
    { name: `${context.nav.news}`, to: "news" },
    { name: `${context.nav.newsletters || "Newsletters"}`, to: "newsletters" },
    { name: `${context.nav.track}`, to: "cases" },
    //{ name: `${context.nav.cases}`, to: "cases" },
  ];

  return (
    <HeaderContainer>
      <NavContainer>
        <Logo to={`/${lang}`}>
          {lang == Language.KOREAN ? (
            <img src="/images/logo/Logo_en.png" alt="위더피플 로고" />
          ) : (
            <img src="/images/logo/Logo_en.png" alt="위더피플 로고" />
          )}
        </Logo>
        <NavLinks>
          <NavLink to="about">{context.nav.intro}</NavLink>
          <NavLink to="practice-areas">{context.nav.practice}</NavLink>
          <NavLink to="members">{context.nav.member}</NavLink>
          <NavLinkWithDropdown
            onMouseEnter={() => setInsightDropdownOpen(true)}
            onMouseLeave={() => setInsightDropdownOpen(false)}
          >
            <DropdownButton>
              {context.nav.insight}
              <DropdownIcon $isOpen={insightDropdownOpen} />
            </DropdownButton>
            <DropdownMenu $isOpen={insightDropdownOpen}>
              {lang == "kr" &&
                InsightSites.map((item, index) => (
                  <DropdownItem_2 key={index} to={item.to}>
                    {item.name}
                  </DropdownItem_2>
                ))}{" "}
              {lang != "kr" &&
                InsightSites_encn.map((item, index) => (
                  <DropdownItem_2 key={index} to={item.to}>
                    {item.name}
                  </DropdownItem_2>
                ))}
            </DropdownMenu>
          </NavLinkWithDropdown>
          <NavLink to="contact">{context.nav.contact}</NavLink>

          {/* 파트너사 드롭다운 메뉴 */}        <NavLinkWithDropdown
            onMouseEnter={() => setPartnerDropdownOpen(true)}
            onMouseLeave={() => setPartnerDropdownOpen(false)}
          >
            <DropdownButton>
              {context.nav.Partners}
              <DropdownIcon $isOpen={partnerDropdownOpen} />
            </DropdownButton>
            <DropdownMenu $isOpen={partnerDropdownOpen}>
              {
                partnerSites.map((item, index) => (
                  <DropdownItem_2 key={index} to={item.url}>
                    {item.name}
                  </DropdownItem_2>
                ))}
            </DropdownMenu>
          </NavLinkWithDropdown>
        
          <LanguageSwitcher />
        </NavLinks>

        <MobileMenuButton onClick={toggleMobileMenu}>
          {mobileMenuOpen ? <CloseIcon /> : <HamburgerIcon />}
        </MobileMenuButton>
      </NavContainer>

      <MobileMenu $isOpen={mobileMenuOpen}>
        <MobileNavLink to={`/${lang}`} onClick={() => setMobileMenuOpen(false)}>
          {context.nav.home}
        </MobileNavLink>
        <MobileNavLink to="about" onClick={() => setMobileMenuOpen(false)}>
          {context.nav.intro}
        </MobileNavLink>
        <MobileNavLink
          to="practice-areas"
          onClick={() => setMobileMenuOpen(false)}
        >
          {context.nav.practice}
        </MobileNavLink>

        <MobileNavLink to="members" onClick={() => setMobileMenuOpen(false)}>
          {context.nav.member}
        </MobileNavLink>    
        <MobileDropdownButton onClick={() => toggleDropdown("insight")}>
          {context.nav.insight}
          <DropdownIcon $isOpen={mobileInsightDropdownOpen} />
        </MobileDropdownButton>
        <MobileDropdownMenu $isOpen={mobileInsightDropdownOpen}>
          {lang == "kr" &&
            InsightSites.map((item, index) => (
              <MobileDropdownItem_2
                key={index}
                to={item.to}
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.name}
              </MobileDropdownItem_2>
            ))}{" "}
          {lang != "kr" &&
            InsightSites_encn.map((item, index) => (
              <MobileDropdownItem_2
                key={index}
                to={item.to}
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.name}
              </MobileDropdownItem_2>
            ))}
        </MobileDropdownMenu>


        <MobileNavLink to="contact" onClick={() => setMobileMenuOpen(false)}>
          {context.nav.contact}
        </MobileNavLink>
        {/* 모바일 파트너사 드롭다운 */}

        {/*
        <MobileNavLink to="partner" onClick={() => setMobileMenuOpen(false)}>
          {context.nav.Partners}
        </MobileNavLink>
        */}
        <MobileDropdownButton onClick={() => toggleDropdown("partner")}>
          {context.nav.Partners}
          <DropdownIcon $isOpen={mobilePartnerDropdownOpen} />
        </MobileDropdownButton>
        <MobileDropdownMenu $isOpen={mobilePartnerDropdownOpen}>
          {partnerSites.map((partner, index) => (
            <MobileDropdownItem
              key={index}
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setMobileMenuOpen(false)}
            >
              {partner.name}
            </MobileDropdownItem>
          ))}
        </MobileDropdownMenu>

        <MobileSw
          language={mobileLanguageDropdownOpen}
          SetLanguage={toggleDropdown}
        />
      </MobileMenu>
    </HeaderContainer>
  );
};

export default Header;
